import request from '@/config/request'

export default {
    searchCard: function (id) {
        return request({
            url: '/project/card/searchcard',
            method: 'get',
            params: {
                id: id
            }
        })
    },
    searchListCard: function (status) {
        return request({
            url: '/project/card/searchlistcard',
            method: 'get',
            params: {
                status: status
            }
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/project/card.js